module.exports = __webpack_public_path__ + "static/media/Malpractice_Insurance.9d527ce9.svg";